import React from 'react';

interface AudioControlsProps {
  musicEnabled: boolean;
  isMuted: boolean;
  onToggleMusic: () => void;
  onToggleMute: () => void;
}

const AudioControls: React.FC<AudioControlsProps> = ({
  musicEnabled,
  isMuted,
  onToggleMusic,
  onToggleMute
}) => {
  return (
    <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-4 mt-4">
      <h3 className="text-sm font-semibold text-gray-700 mb-3">Audio Controls</h3>
      <div className="flex gap-2">
        <button
          onClick={onToggleMusic}
          className="flex-1 bg-gray-100 rounded-lg p-3 hover:bg-gray-200 transition-colors border border-gray-300"
          title={musicEnabled ? 'Disable music' : 'Enable music'}
        >
          <div className="text-center">
            <span className="text-2xl block mb-1">{musicEnabled ? '🎵' : '🔇'}</span>
            <span className="text-xs text-gray-600">Music</span>
          </div>
        </button>
        <button
          onClick={onToggleMute}
          className="flex-1 bg-gray-100 rounded-lg p-3 hover:bg-gray-200 transition-colors border border-gray-300"
          title={isMuted ? 'Enable sound effects' : 'Disable sound effects'}
        >
          <div className="text-center">
            <span className="text-2xl block mb-1">{isMuted ? '🔕' : '🔔'}</span>
            <span className="text-xs text-gray-600">SFX</span>
          </div>
        </button>
      </div>
    </div>
  );
};

export default AudioControls;
